<template>
    <v-navigation-drawer
      v-model="drawerOpen"
      app
      right
      temporary
      :width="$vuetify.breakpoint.smAndDown ? '100%' : '50%'"
    >
      <v-toolbar color="primary" dark>
        <v-toolbar-title>Notifications</v-toolbar-title>
        <v-spacer></v-spacer>
         <!-- <v-btn icon >  -->
            <v-icon> {{ $store.state.isNotificationEnabled ? "mdi-bell-ring" : "mdi-bell-off" }}</v-icon>
          <!-- </v-btn> -->
        <v-switch 
          class="mt-5 ml-2"          
          v-model="$store.state.isNotificationEnabled"
          @change="$store.dispatch('toggleNotification')">
        </v-switch>        
        <v-spacer></v-spacer>
        <v-btn icon @click="closeDrawer">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-alert 
        v-if="$store.getters['pushNotificationPermission'].state === 'denied'"       
        dismissible
        color="red"
        border="left"
        elevation="1"
        colored-border
        icon="mdi-bell-alert"
      >
        <v-row align="center">
          <v-col class="grow">
            Push notifications are denied.
          </v-col>
          <!-- <v-col class="shrink">
            <v-btn  v-if="showUpdateButton" color="amber" @click="updateApp">Update</v-btn>
          </v-col> -->
        </v-row>        
      </v-alert>
  
      <v-tabs>
        <v-tab>ALL ({{ allCount }})</v-tab>
        <v-tab>Notifications ({{ unreadNotificationsCount }})</v-tab>
        <v-tab>Messages ({{ unreadMessagesCount }})</v-tab>
        <v-tab>Reminders({{ unreadMessagesCount }})</v-tab>
        <v-tab-item>
          <v-list two-line>
            <v-list-item v-for="item in allNotifications" :key="item.id" @click="markAsRead(item)">
              <v-list-item-content>
                <v-list-item-title :class="{ 'font-weight-bold': !item.read }">
                  {{ item.title }}
                </v-list-item-title>
                <v-list-item-subtitle>{{ item.body }}</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-icon v-if="!item.read" color="primary">mdi-circle-small</v-icon>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-tab-item>
  
        <v-tab-item>
          <v-list two-line>
            <v-list-item v-for="notification in notifications" :key="notification.id" @click="markAsRead(notification)">
              <v-list-item-content>
                <v-list-item-title :class="{ 'font-weight-bold': !notification.read }">
                  {{ notification }}
                </v-list-item-title>
                <v-list-item-subtitle>{{ notification.body }}</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-icon v-if="!notification.read" color="primary">mdi-circle-small</v-icon>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-tab-item>
  
        <v-tab-item>
          <v-list two-line>
            <v-list-item v-for="message in messages" :key="message.id" @click="markAsRead(message)">
              <v-list-item-content>
                <v-list-item-title :class="{ 'font-weight-bold': !message.read }">
                  {{ message.title }}
                </v-list-item-title>
                <v-list-item-subtitle>{{ message.body }}</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-icon v-if="!message.read" color="primary">mdi-circle-small</v-icon>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-tab-item>
      </v-tabs>
    </v-navigation-drawer>
  </template>
  
  <script>
  export default {
    name: 'NotificationDrawer',
    
    computed: {
      notifications() {
        return this.$store.state.notifications.notifications;
      },
      messages() {
        return this.$store.state.notifications.messages;
      },
      allNotifications() {
        return [...this.notifications, ...this.messages].sort((a, b) => b.timestamp - a.timestamp);
      },
      unreadNotificationsCount() {
        return this.notifications.filter(n => !n.read).length;
      },
      unreadMessagesCount() {
        return this.messages.filter(m => !m.read).length;
      },
      drawerOpen: {
        get() {
          return this.$store.state.notifications.drawerOpen;
        },
        set(value) {
          this.$store.commit('notifications/SET_DRAWER_OPEN', value);
        }
      },
      allCount() {
        return this.unreadNotificationsCount + this.unreadMessagesCount;
      }
    },
    
    methods: {
      closeDrawer() {
        this.$store.dispatch('notifications/toggleNotificationDrawer');
      },
      markAsRead(item) {
        this.$store.dispatch('notifications/markAsRead', { id: item.id, type: item.type });
      }
    }
  };
</script>
<style scoped>
.v-navigation-drawer {
transition: transform 0.3s ease-in-out;
}

@media (max-width: 600px) {
.v-navigation-drawer {
    width: 100% !important;
}
}
</style>